export enum TagAssignment {
  Direct,
  FromParent,
  FromTemplate,
}
